import React from 'react';
import { Tag } from 'antd';
import { EXECUTION_STATE, getExecutionStateLabelId } from '@src/models/execution';
import { useIntl } from 'react-intl';
import styles from './styles.module.less';
import classNames from 'classnames';

/**
 * Renders a tag component representing the execution status.
 *
 * @component
 * @param {string} status - The execution status. Possible values are:
 *   - "active": Represents an active execution status.
 *   - "inactive": Represents an inactive execution status.
 *   - "completed": Represents a completed execution status.
 *   - "incomplete": Represents an incomplete execution status.
 *   - Any other value represents an expired execution status.
 * @returns {JSX.Element} The rendered ExecutionStatus component.
 */

const ExecutionStatus = ({ status, className }) => {
  const intl = useIntl();
  let colorClass = null;
  let executionStatus;

  switch (status) {
    case EXECUTION_STATE.active:
      colorClass = styles.active;
      executionStatus = intl.formatMessage({ id: 'work.order.status.active' });
      break;
    case EXECUTION_STATE.stalled:
      colorClass = styles.stalled;
      executionStatus = intl.formatMessage({ id: 'work.order.status.stalled' });
      break;
    case EXECUTION_STATE.inactive:
      colorClass = styles.inactive;
      executionStatus = intl.formatMessage({ id: 'work.order.status.inactive' });
      break;
    case EXECUTION_STATE.completed:
      colorClass = styles.completed;
      executionStatus = intl.formatMessage({ id: 'work.order.status.completed' });
      break;
    case EXECUTION_STATE.incomplete:
      colorClass = styles.incomplete;
      executionStatus = intl.formatMessage({ id: 'work.order.status.incomplete' });
      break;
    case EXECUTION_STATE.unassigned:
      colorClass = styles.unassigned;
      executionStatus = intl.formatMessage({ id: 'work.order.status.unassigned' });
      break;
    case EXECUTION_STATE.complete_expired:
      colorClass = styles.completeExpired;
      executionStatus = intl.formatMessage({ id: 'work.order.status.complete_expired' });
      break;
    case EXECUTION_STATE.incomplete_partial:
      colorClass = styles.incompletePartial;
      executionStatus = intl.formatMessage({ id: 'work.order.status.incomplete_partial' });
      break;
    case EXECUTION_STATE.canceled:
      colorClass = styles.canceled;
      executionStatus = intl.formatMessage({ id: 'work.order.status.canceled' });
      break;
    case EXECUTION_STATE.expired:
      colorClass = styles.expired;
      executionStatus = intl.formatMessage({ id: 'work.order.status.expired' });
      break;
    default:
      colorClass = styles.inactive;
      executionStatus = intl.formatMessage({ id: getExecutionStateLabelId(status) });
      break;
  }

  return (
    <Tag className={classNames(colorClass, styles.tagStatus, className)}>{executionStatus}</Tag>
  );
};

export default React.memo(ExecutionStatus);
